/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import rolesPermissions from './Adapter';
// import { useParams } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table';
import { API_HIERARCHYMODULE, API_MENU, API_ROLE, LANDINGPAGE } from '../../../../commons/api';
import { EditOutlined, DeleteOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Drawer,
  Button,
  Form,
  Input,
  Checkbox,
  Row,
  Tree,
  Popconfirm,
  message,
  Select,
  Tooltip,
  Radio,
  Divider
} from 'antd';

const { TreeNode } = Tree;
const { Option } = Select;

const Role = (props) => {
  const RoleConfigRef = useRef(null);
  const searchInputRef = useRef(null);

  const [visible, setVisible] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [siteId, setSiteId] = useState('');
  const [moduleList, setModuleList] = useState([]);
  const [configurationList, setConfigurationList] = useState([]);
  const [landingPageList, setLandingPageList] = useState([]);
  const [HierarchyList, setHierarchyList] = useState([]);
  const [permissionsList, setPermissionsList] = useState({});
  const [checkedConfiguartionKeys, setCheckedConfiguartionKeys] = useState([]);
  const [checkedModuleKeys, setCheckedModuleKeys] = useState([]);
  const [checkedApplicationSettingsKeys, setCheckedApplicationSettingsKeys] = useState([]);
  const [checkedPermissionsKeys, setCheckedPermissionsKeys] = useState({
    asset_device: [],
    dashboard: [],
    timeScale: []
  });
  const [datasource, setDatasource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [menuType, setMenuType] = useState('Web');
  const [applicationList, setApplicationList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  useEffect(() => {
    let siteId =  localStorage.get('currentSite');
    setSiteId(siteId);
  }, [siteId]);


  useEffect(() => {
    _getRolesList(siteId);
    _getPermissionsList();
    _getLandingPageList();
    getHierarchyList();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
        setTranslationCache(props.translationCache);
      }
  }, [props.translationCache]);

  const _getPermissionsList = () => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgHeaders = {
      method: 'GET',
      url: `${API_ROLE.Permissions}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setPermissionsList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _getRolesList = () => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgHeaders = {
      method: 'GET',
      url: `${API_ROLE.GET}?SiteId=${siteId}&menuType=${menuType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setDatasource(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _getRolesById = async (menuType, Id) => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgHeaders = {
      method: 'GET',
      url: `${API_ROLE.GET}?SiteId=${siteId}&menuType=${menuType}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    try {
      const response = await axios(orgHeaders);
      return response.data;
    } catch (error) {
      console .log(error);
      return [];
    }
  };

  const _getModuleList = (menuType) => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgHeaders = {
      method: 'GET',
      url: `${API_MENU.Get}?SiteId=${siteId}&Type=Structured&menuType=${menuType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        if (response.data[0]) {
          let configurationList = rolesPermissions.menuListAdapter(response.data[0].Configuration);
          let moduleList = rolesPermissions.menuListAdapter(response.data[0].Modules);
          let applicationList = rolesPermissions.menuListAdapter(response.data[0].ApplicationSettings);
          setModuleList(moduleList);
          setConfigurationList(configurationList);
          setApplicationList(applicationList);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getHierarchyList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let headers = {
      method: 'GET',
      url: `${API_HIERARCHYMODULE.MainHierarchyList}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          setHierarchyList(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _getLandingPageList = () => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgHeaders = {
      method: 'GET',
      url: `${LANDINGPAGE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setLandingPageList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const showDrawer = () => {
    if (RoleConfigRef.current) {
      RoleConfigRef.current.resetFields();
    }
    setEditObj({});
    setVisible(true);
    setCheckedConfiguartionKeys([]);
    setCheckedModuleKeys([]);
    setCheckedApplicationSettingsKeys([]);
    setCheckedPermissionsKeys({
      asset_device: [],
      dashboard: [],
      timeScale: []
    });
  };

  const onClose = () => {
    if (RoleConfigRef.current) {
      RoleConfigRef.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

  const _updateRole = (updateObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let updateHeader = {
      method: 'PATCH',
      url: `${API_ROLE.UPDATE}?SiteId=${siteId}&menuType=${menuType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: updateObject
    };
    axios(updateHeader)
      .then((response) => {
        if (response && response.data) {
          _getRolesList();
          RoleConfigRef.current.resetFields();
          message.success(response.data.message);
          setVisible(false);
          setEditObj({});
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _saveRole = (createObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgCreateHeaders = {
      method: 'POST',
      url: `${API_ROLE.CREATE}?SiteId=${siteId}&menuType=${menuType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: createObject
    };
    axios(orgCreateHeaders)
      .then((response) => {
        if (response && response.data) {
          _getRolesList();
          RoleConfigRef.current.resetFields();
          message.success(response.data.message);
          setVisible(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _deleteRole = (role) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgDeleteHeaders = {
      method: 'DELETE',
      url: `${API_ROLE.DELETE}?SiteId=${siteId}&Id=${role.Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success('Role Deleted');
          _getRolesList();
          RoleConfigRef.current.resetFields();
          setVisible(false);
        } else {
          message.error('Error in delete');
        }
      })
      .catch(() => { });
  };

  const openDrawer = (e, record, menuType) => {
    let checkedPermissionsKeys = rolesPermissions.permissionAdapter(record.Permission);
    _getModuleList(menuType);
    if (RoleConfigRef.current) {
      RoleConfigRef.current.setFieldsValue(record);
    }
    setVisible(true);
    setEditObj(record);
    setCheckedPermissionsKeys(checkedPermissionsKeys);
    setCheckedModuleKeys(record.Modules);
    setCheckedConfiguartionKeys(record.Configuration);
    setCheckedApplicationSettingsKeys(record.ApplicationSettings);
  };

  const onCheck = (name, checkedKey) => {
    if (name === 'configuration') {
      setCheckedConfiguartionKeys(checkedKey);
    } else if (name === 'module') {
      setCheckedModuleKeys(checkedKey);
    } else if (name === 'applicationSettings') {
      setCheckedApplicationSettingsKeys(checkedKey);
    }
  };

  const onSubmit = (operation) => {
    // let {
    //   checkedConfiguartionKeys,
    //   checkedApplicationSettingsKeys,
    //   checkedPermissionsKeys,
    //   checkedModuleKeys,
    //   siteId,
    //   editObj
    // } = { checkedConfiguartionKeys, checkedApplicationSettingsKeys, checkedPermissionsKeys, checkedModuleKeys, siteId, editObj };
    RoleConfigRef.current &&
      RoleConfigRef.current
        .validateFields()
        .then(async (values) => {
          let Permission = [];
          if (checkedPermissionsKeys) {
            Permission = rolesPermissions.createPermissions(checkedPermissionsKeys);
          }
          let saveObject = {
            ...editObj,
            ...values,
            OrganizationId: 1,
            SiteId: siteId,
            Permission,
            Modules: checkedModuleKeys || [],
            Configuration: checkedConfiguartionKeys || [],
            ApplicationSettings: checkedApplicationSettingsKeys || []
          };

          if (operation === 'create') {
            _saveRole(saveObject);
          } else if (operation === 'update') {
            _updateRole(saveObject);
          }
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const renderTreeNodes = (data) =>
    data &&
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode title={item.title} key={item.key} dataRef={item}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode key={item.key} {...item} />;
    });

  const onChange = (checkedValues, title) => {
    let newObj = {
      ...checkedPermissionsKeys,
      [title]: checkedValues
    };
    setCheckedPermissionsKeys(newObj);
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFinishFailed = () => {
    message.error('please enter required fields');
  };

  const handleSelectAll = (e) => {
    let checkedPermissionsKeys = [];
    if (e.target.checked === true) {
      let modules = Object.keys(permissionsList);
      modules &&
        Array.isArray(modules) &&
        modules.forEach((module) => {
          checkedPermissionsKeys = {
            ...checkedPermissionsKeys,
            [module]: permissionsList[module].permission.map((p) => p.value)
          };
        });
      setCheckedPermissionsKeys(checkedPermissionsKeys);
    } else if (e.target.checked === false){
      setCheckedPermissionsKeys([]);
    }
  };

  const handleSelectAllConfig = (e) => {
    let checkedConfiguartionKeys = [];
    if (e.target.checked === true) {
      configurationList && Array.isArray(configurationList) && configurationList.forEach((c) => {
        checkedConfiguartionKeys.push(c.key);
      });
      setCheckedConfiguartionKeys(checkedConfiguartionKeys);
    } else if (e.target.checked === false){
      setCheckedConfiguartionKeys([]);
    }
  };

  const handleSelectAllModule = (e) => {
    let checkedModuleKeys = [];
    if (e.target.checked === true) {
      moduleList && Array.isArray(moduleList) && moduleList.forEach((module) => {
        checkedModuleKeys.push(module.key);
      });
      setCheckedModuleKeys(checkedModuleKeys);
    } else if (e.target.checked === false){
      setCheckedModuleKeys([]);
    }
  };

  const handleSelectAllSettings = (e) => {
    let checkedApplicationSettingsKeys = [];
    if (e.target.checked === true) {
      applicationList && Array.isArray(applicationList) && applicationList.forEach((app) => {
        checkedApplicationSettingsKeys.push(app.key);
      });
      setCheckedApplicationSettingsKeys(checkedApplicationSettingsKeys);
    } else {
      setCheckedApplicationSettingsKeys([]);
    }
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    ),
  });

  const onMenuTypeChange = async (menuType) => {
    let editObj = {};
    if (editObj && editObj.Id) {
      let editObj1 = await _getRolesById(menuType, editObj.Id);
      editObj = editObj1 && editObj1[0] ? editObj1[0] : {};
    } else {
      editObj = {};
    }

    setMenuType(menuType);
    openDrawer('', editObj, menuType);
  };

  const columns = [
    {
      title: translation('Role Name'),
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation('Description'),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation('Action'),
      dataIndex: '',
      key: '',
      render: (text, record) => (
        <div>
          <Tooltip title={translation('Edit')}>
            <Button
              type="primary"
              onClick={(e) => openDrawer(e, record, menuType)}
              style={{ marginRight: '10px' }}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
          {record && record.Default && record.Default !== true ? (
            <Popconfirm
              title={translation('Are you sure delete Role ?')}
              onConfirm={(e) => {
                e.stopPropagation();
                _deleteRole(record);
              }}
              okText={translation('Yes')}
              cancelText={translation('No')}
            >
              <Tooltip title={translation('Delete')}>
                <Button type="primary">
                  <DeleteOutlined />
                </Button>
              </Tooltip>
            </Popconfirm>
          ) : null}
        </div>
      )
    }
  ];

  return (
    <>
      <Drawer
        title={editObj && editObj.Id ? translation('Update Role') : translation('Create Role')}
        placement="right"
        width={650}
        closable
        onClose={onClose }
        open={visible}
      >
        <Form
          layout="vertical"
          ref={RoleConfigRef}
          name="Role_form"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          initialValues={editObj || {}}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label={<div style={{ fontWeight: 'bold' }}>{translation('Role Name')}</div>}
            name="Name"
            rules={[{ required: true, message: 'Please input your rolename!' }]}
          >
            <Input
              placeholder={translation('Please enter Role Name')}
              disabled={editObj.Id ? true : false}
            />
          </Form.Item>

          <Form.Item
            label={<div style={{ fontWeight: 'bold' }}>{translation('Description')}</div>}
            name="Description"
            rules={[{ required: true, message: 'Please input your description!' }]}
          >
            <Input placeholder={translation('Please enter Description')} />
          </Form.Item>

          <Form.Item
            label={<div style={{ fontWeight: 'bold' }}>{translation('Landing Page')}</div>}
            name="LandingPageId"
            rules={[{ required: true, message: 'Please select Landing Page !' }]}
          >
            <Select>
              {landingPageList.map((value, index) => (
                <Option key={index} value={value.Id}>
                  {value.Name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={<div style={{ fontWeight: 'bold' }}>{translation('Hierarchy')}</div>}
            name="Hierarchy"
            rules={[{ required: true, message: 'Please select Hierarchy!' }]}
          >
            <Select mode="multiple">
              {HierarchyList.map((value, index) => (
                <Option key={index} value={value.Id}>
                  {value.HierarchyName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Checkbox onChange={(e) => handleSelectAll(e, 'selectAll')}>Select All</Checkbox>

          {Object.keys(permissionsList).map((permissionName, index) => {
            let { name, key, permission } = permissionsList[permissionName];
            return (
              <Form.Item
                key={index}
                label={<div style={{ fontWeight: 'bold' }}>{translation(name)}</div>}
              >
                <Checkbox.Group
                  value={checkedPermissionsKeys && checkedPermissionsKeys[key] ? checkedPermissionsKeys[key] : []}
                  onChange={(e) => onChange(e, key)}
                >
                  <Row>
                    {permission && Array.isArray(permission) && permission.map(({ label, value }) => (
                      <Checkbox key={value} value={value}>
                        {translation(label)}
                      </Checkbox>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            );
          })}

          <Form.Item>
            <Radio.Group
              style={{ float: 'right' }}
              onChange={(e) => onMenuTypeChange(e.target.value)}
              value={menuType}
            >
              <Radio value={'Web'}>Web</Radio>
              <Radio value={'Mobile'}>Mobile</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label={<div style={{ fontWeight: 'bold' }}>{translation('Configuration')}</div>}>
            <Checkbox style={{ marginLeft: '23px' }} onChange={(e) => handleSelectAllConfig(e, 'selectAll')}>
              Select all
            </Checkbox>
            <Divider style={{ background: '#e6e5e5', margin: '5px 0px' }} />
            <Tree
              defaultExpandAll={true}
              checkable
              onCheck={(e) => onCheck('configuration', e)}
              checkedKeys={checkedConfiguartionKeys}
            >
              {renderTreeNodes(configurationList)}
            </Tree>
          </Form.Item>

          <Form.Item label={<div style={{ fontWeight: 'bold' }}>{translation('Modules')}</div>}>
            <Checkbox style={{ marginLeft: '23px' }} onChange={(e) => handleSelectAllModule(e, 'selectAll')}>
              Select all
            </Checkbox>
            <Divider style={{ background: '#e6e5e5', margin: '5px 0px' }} />
            <Tree
              defaultExpandAll={true}
              checkable
              onCheck={(e) => onCheck('module', e)}
              checkedKeys={checkedModuleKeys}
            >
              {renderTreeNodes(moduleList)}
            </Tree>
          </Form.Item>

          <Form.Item label={<div style={{ fontWeight: 'bold' }}>{translation('Application Settings')}</ div>}>
            <Checkbox style={{ marginLeft: '23px' }} onChange={(e) => handleSelectAllSettings(e, 'selectAll')}>
              Select all
            </Checkbox>
            <Divider style={{ background: '#e6e5e5', margin: '5px 0px' }} />
            <Tree
              defaultExpandAll={true}
              style={{ marginBottom: '50px' }}
              checkable
              onCheck={(e) => onCheck('applicationSettings', e)}
              checkedKeys={checkedApplicationSettingsKeys}
            >
              {renderTreeNodes(applicationList)}
            </Tree>
          </Form.Item>
        </Form>
        <div
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            textAlign: 'center',
            background: 'inherit',
          }}
        >
          <Button type='primary' onClick={onClose} style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          {Object.keys(editObj).length === 0 ? (
            <Button type='primary' onClick={() => onSubmit('create')}>
              {translation('Create')}
            </Button>
          ) : (
            <Button type='primary' onClick={() => onSubmit('update')}>
              {translation('Update')}
            </Button>
          )}
        </div>
      </Drawer>

      <Button
        type="primary"
        onClick={showDrawer}
        style={{
          marginBottom: '10px',
          border: 'white'
        }}
      >
        <PlusOutlined />
        {translation('Add')}
      </Button>

      <StyledTable size="small"
        dataSource={datasource}
        columns={columns}
        bordered
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(Role);